module.exports = __webpack_public_path__ + "img/Farm.b76e79e8.svg";